import { METRICS, type MetricKey } from '../metrics';

/**
 * Cabeçalho de coluna com a explicação da métrica no hover.
 *
 * O texto vem do dicionário em `metrics.ts` — repetir aqui criaria uma segunda
 * definição da mesma coisa, e elas divergiriam.
 */
export function MetricHead({
    metric,
    align = 'right',
    label,
}: {
    metric: MetricKey;
    align?: 'left' | 'right';
    label?: string;
}) {
    return (
        <th
            className={`px-4 py-2 font-medium ${align === 'left' ? 'text-left' : 'text-right'}`}
            title={`${METRICS[metric].label} — ${METRICS[metric].short}`}
        >
            <span className="cursor-help border-b border-dotted border-gray-300">
                {label ?? METRICS[metric].label}
            </span>
        </th>
    );
}
